import { apiFetch } from "../apiClient";
import type { MemberAnalytics, MemberPage, OwnerBrandingRequest, OwnerLogoUpload, Tenant } from "../../types";

export function listOwnerTenants(token: string): Promise<{ tenants: Tenant[] }> {
  return apiFetch("/owner/tenants", { token });
}
export function requestOwnerLogoUpload(
  token: string,
  tenantId: string,
  contentType: string,
): Promise<OwnerLogoUpload> {
  return apiFetch(`/owner/tenants/${encodeURIComponent(tenantId)}/logo-upload`, {
    method: "POST",
    token,
    body: { contentType },
  });
}

export async function uploadOwnerLogo(upload: OwnerLogoUpload, file: File): Promise<void> {
  const form = new FormData();
  for (const [name, value] of Object.entries(upload.uploadFields)) {
    form.append(name, value);
  }
  form.append("file", file);
  const response = await fetch(upload.uploadUrl, { method: "POST", body: form });
  if (!response.ok) {
    throw new Error("The logo upload failed. Try again.");
  }
}

export function updateOwnerBranding(
  token: string,
  tenantId: string,
  branding: OwnerBrandingRequest,
): Promise<{ tenant: Tenant }> {
  return apiFetch(`/owner/tenants/${encodeURIComponent(tenantId)}/branding`, {
    method: "PUT",
    token,
    body: branding,
  });
}

export function listOwnerMembers(
  token: string,
  tenantId: string,
  params: { limit?: number; cursor?: string } = {},
): Promise<MemberPage> {
  const query = new URLSearchParams();
  query.set("limit", String(params.limit ?? 50));
  if (params.cursor) query.set("cursor", params.cursor);
  return apiFetch(`/owner/tenants/${encodeURIComponent(tenantId)}/members?${query.toString()}`, { token });
}

export function getOwnerAnalytics(token: string, tenantId: string): Promise<{ analytics: MemberAnalytics }> {
  return apiFetch(`/owner/tenants/${encodeURIComponent(tenantId)}/analytics`, { token });
}
